import { COUNTRY_LIST } from "./countries";

const COUNTRY_NAMES: Record<number, string> = Object.fromEntries(
  COUNTRY_LIST.map((country) => [country.id, country.name])
);

export const getCountryName = (countryId?: number | null) =>
  (countryId && COUNTRY_NAMES[countryId]) || "";

export const COUNTRY_OPTIONS = COUNTRY_LIST.map((country) => ({
  value: String(country.id),
  label: country.name,
}));

export const ORGANISATIONS_PAGE_SIZE = 5;
